'use strict';

import type { Automation } from '../../Entities/Automation/Automation';
import { EntityCollection } from '../EntityCollection';

export class AutomationCollection extends EntityCollection<Automation> {}
